import { Dialog } from "@mui/material";
import React from "react";
import SecondaryButton from "../button/SecondaryButton";

export default function ErrorPopup(props) {
    const {
        onClose,
        selectedValue,
        open,
        // confirmType = true,
    } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    return (
        <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth="xl">
            <div className="pb-[24px] pt-[22px] px-[22px] rounded-[4px]">
                <p className="text-[24px] font-bold text-center text-red">
                    ขออภัย
                </p>
                <p className="text-[24px] font-bold text-center text-red">
                    ดูเหมือนว่าจะมีบางอย่างผิดพลาด
                </p>
                <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[100%]">
                    โปรดตรวจสอบและลองใหม่อีกครั้ง
                </p>
                <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
                    <SecondaryButton
                        onClick={() => props.actionFunction()}
                        variant="outlined"
                        className="w-[50%]"
                    >
                        ปิด
                    </SecondaryButton>
                </div>
            </div>
        </Dialog>
    );
}
